'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_COLOR = exports.NST_OUT_LENGTH = exports.OUT_LENGTH = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * Copyright (c) 2018-present, Leap DAO (leapdao.org)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * This source code is licensed under the GNU Affero General Public License,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * version 3, found in the LICENSE file in the root directory of this source
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * tree.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       */


var _assert = require('assert');

var _assert2 = _interopRequireDefault(_assert);

var _jsbiUtils = require('jsbi-utils');

var _util = require('./util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} // 32 bytes - value, 20 bytes - address, 2 bytes color


var OUT_LENGTH = exports.OUT_LENGTH = 54; // 32 - data, + normal output like above

var NST_OUT_LENGTH = exports.NST_OUT_LENGTH = OUT_LENGTH + 32;
var MAX_COLOR = exports.MAX_COLOR = Math.pow(2, 16);

var valueHex = function valueHex(value) {
  return (0, _jsbiUtils.BigInt)(value).toString(16);
};

var Output = function () {
  function Output(valueOrObject, address, color, data) {
    _classCallCheck(this, Output);

    if ((typeof valueOrObject === 'undefined' ? 'undefined' : _typeof(valueOrObject)) === 'object' && !(0, _jsbiUtils.isBigInt)(valueOrObject)) {
      (0, _util.ensureSafeValue)(valueOrObject.value);
      this.value = (0, _jsbiUtils.BigInt)(valueOrObject.value);
      this.color = valueOrObject.color;
      this.address = valueOrObject.address;

      if (this.isNST()) {
        this.data = valueOrObject.data;
      }
    } else {
      (0, _util.ensureSafeValue)(valueOrObject);
      this.value = (0, _jsbiUtils.BigInt)(valueOrObject);
      this.address = address;
      this.color = color;

      if (this.isNST()) {
        this.data = data;
      }
    }

    if ((0, _jsbiUtils.lessThan)(this.value, (0, _jsbiUtils.BigInt)(1))) {
      throw new Error('Output value is < 1');
    }

    if (this.color < 0 || this.color > MAX_COLOR) {
      throw new Error("Color out of range (0\u2013" + MAX_COLOR + ')');
    }

    if (this.isNST() && !(0, _util.isBytes32)(this.data)) {
      throw new Error('data is not a 32 bytes hex string');
    }
  }

  _createClass(Output, [{
    key: 'isNFT',
    value: function isNFT() {
      return (0, _util.isNFT)(this.color);
    }
  }, {
    key: 'isNST',
    value: function isNST() {
      return (0, _util.isNST)(this.color);
    }
    /* eslint-disable class-methods-use-this */

  }, {
    key: 'getSize',
    value: function getSize() {
      // transfer output
      return this.isNST() ? NST_OUT_LENGTH : OUT_LENGTH;
    }
    /* eslint-enable class-methods-use-this */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var rsp = {
        address: this.address,
        value: this.value.toString(10),
        color: this.color
      };

      if (this.isNST()) {
        rsp.data = this.data;
      }

      return rsp;
    }
    /**
       * Instantiate output from json object.
       * @param {Object} json
       * @returns {Outpoint}
       */

  }, {
    key: 'toRaw',
    value: function toRaw() {
      var dataBuf = Buffer.alloc(this.getSize());
      dataBuf.write(valueHex(this.value).padStart(64, '0'), 0, 32, 'hex');
      dataBuf.writeUInt16BE(this.color, 32);
      dataBuf.write(this.address.replace('0x', ''), 34, 'hex');

      if (this.isNST()) {
        dataBuf.write(this.data.replace('0x', ''), 54, 'hex');
      }

      return dataBuf;
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(json) {
      (0, _assert2.default)(json, 'Output data is required.');
      return new Output(json);
    }
    /**
     * Instantiate output from serialized data.
     * @param {Buffer} data
     * @param {offset} offset to read from in buffer
     * @returns {Output}
     */

  }, {
    key: 'fromRaw',
    value: function fromRaw(buf) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var color = buf.readUInt16BE(offset + 32);
      var valueString = (0, _util.toHexString)(buf.slice(offset, offset + 32));
      var value = (0, _jsbiUtils.BigInt)(valueString);
      var address = (0, _util.toHexString)(buf.slice(offset + 34, offset + 54));
      var data = void 0;

      if ((0, _util.isNST)(color)) {
        data = (0, _util.toHexString)(buf.slice(offset + 54, offset + 54 + 32));
      } // transfer output


      return new Output(value, address, color, data);
    }
  }]);

  return Output;
}();

exports.default = Output;